import React from 'react';
import { useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';

import useGlobal from '../../../../store';
import ResponseError from '../../../../shared/responses/ResponseError';
import ResponseResult from '../../../../shared/responses/ResponseResult';
import RetencionesMasivasFilesUploadForm from '../components/RetencionesMasivasFilesUploadForm';

const mapState = (store) => {
  const { retenciones_masivas } = store.modulo;

  return {
    files: retenciones_masivas.files.list,
    upload: retenciones_masivas.files.upload,
  };
};

const mapActions = (actions) => {
  const { retenciones_masivas } = actions.modulo;

  return {
    files: retenciones_masivas.files.list,
    upload: retenciones_masivas.files.upload,
  };
};

const RetencionesMasivasFilesUpload = (props) => {
  const [state, actions] = useGlobal(mapState, mapActions);
  const { data, busy, result, error } = state.upload;

  const isValid = !!data.tipo && !!data.file;

  useEffect(() => {
    return () => {
      actions.upload.reset();
    };
  }, []); // eslint-disable-line

  const handleOnClose = () => {
    if (!busy) {
      props.history.replace('/modulos/retenciones-masivas/files');
    }
  };

  const handleOnUpload = () => {
    actions.upload.upload((event) => {
      actions.upload.progress(Math.round((100 * event.loaded) / event.total));
    });
  };

  useEffect(() => {
    if (!!result && state.files.pagination.page === 1) {
      actions.files.paginate({});
    }
  }, [result]); // eslint-disable-line

  if (!!result) {
    return (
      <div className="result-container">
        <ResponseResult
          title="Archivo enviado"
          result={result}
          onAction={handleOnClose}
        />
      </div>
    );
  }

  if (!!error) {
    return (
      <div className="result-container">
        <ResponseError
          title="Error"
          error={error}
          onAction={handleOnClose}
        />
      </div>
    );
  }

  return (
    <Modal
      backdrop="static"
      keyboard={false}
      show={true}
      centered={true}
      onHide={handleOnClose}
    >
      <Modal.Header closeButton>
        <Modal.Title>Subir archivo</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <RetencionesMasivasFilesUploadForm />
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          disabled={busy}
          onClick={handleOnClose}
        >
          Close
        </Button>
        <Button
          variant="primary"
          disabled={busy || !isValid}
          onClick={handleOnUpload}
        >
          Subir
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RetencionesMasivasFilesUpload;
